<template>
  <div>
    <div class="terms-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="subtitle">Reklamacije</h2>
            <div>
              <p><strong>Za privatne kupce:</strong></p>
              <p>
                Ukoliko ustanovite, prilikom prve upotrebe (unutar 7 dana od primitka), da je
                proizvod koji ste dobili neispravan molimo Vas da nas kontaktirate i slijedite
                navedene korake:
              </p>
              <p>
                Po&scaron;aljite nam informacije s brojem narudžbe, brojem računa ili va&scaron;im
                korisničkim imenom i opisom reklamacije putem <strong>e-mail adrese </strong
                ><a href="mailto:webshop@eurosan.ba"><strong>webshop@eurosan.ba</strong></a
                ><strong> ili telefonski na 080 080 080.</strong>
              </p>
              <p>
                Poslat ćemo Vam potvrdu primitka reklamacije i, temeljem Va&scaron;eg opisa
                reklamacije, informaciju o tome može li se proizvod zamijeniti za novi i može li se
                za proizvod vratiti novac.&nbsp;&nbsp;&nbsp;
              </p>
              <p>
                U slučajevima kad se proizvod može zamijeniti za novi i kad se za proizvod može
                vratiti novac, na Va&scaron;u adresu &scaron;aljemo dostavnu službu koja prikuplja
                reklamirani proizvod i vraća na na&scaron;e skladi&scaron;te. Va&scaron;a obaveza je
                da proizvod zapakujete i spremite za preuzimanje brze po&scaron;te u originalnoj
                ambalaži sa svim dodacima i dokumentacijom koju ste dobili uz proizvod. Kad proizvod
                stigne na skladi&scaron;te, nakon &scaron;to bude pregledan, &scaron;aljemo Vam
                obavijest o povratu novaca/slanju zamjenskog proizvoda. Povrat novca/zamjena za novi
                proizvod bit će odrađena unutar 2-3 dana, a najkasnije nakon 15 dana. U suprotnom
                nas kontaktirajte telefonski na 080 080 080 ili e-mailom na webshop@eurosan.ba
              </p>
              <p>
                Ako je ambalaža o&scaron;tećena nemojte preuzimati proizvod, nego dostavljaču
                skrenite pažnju na o&scaron;tećenje ambalaže i zatražite da proizvod vrati u
                Eurosan. Ako kupac ne reklamira o&scaron;tećenje ambalaže dostavljaču u trenutku
                preuzimanja proizvoda, smatra se da je preuzeo proizvod s neo&scaron;tećenom
                ambalažom.
              </p>
              <p>
                U slučaju da proizvod koji ste dobili ne odgovara slikom ili specifikacijom
                proizvodu koji ste naručili isti možete zamijeniti ili vratiti u zamjenu za novac
                unutar 7 dana od primitka. Za ostvarivanje ovog prava, potrebno je neo&scaron;tećeni
                proizvod poslati u originalnom pakiranju sa svom opremom i dokumentacijom s kojim je
                proizvod bio originalno isporučen.
              </p>
              <p><strong>Za poslovne kupce:</strong></p>
              <p>
                Poslovni kupci popunjavaju obrazac zvani 'Reklamacije' pomoću kojeg &scaron;alju
                reklamacije poduzeću Eurosan d.o.o. Na eurosan.ba web shopu u odjeljku 'Moj profil'
                se nalazi obrazac koji popunjavate na način da upi&scaron;ete kontakt osobu, naziv i
                &scaron;ifru proizvoda, brend, serijski broj, upi&scaron;ete opis, priložite sliku,
                te napi&scaron;ete broj računa. Na kraju kliknete po&scaron;alji, a na istom mjestu
                možete pratiti stanje va&scaron;e reklamacije, da li je na čekanju ili
                zavr&scaron;ena. Na isti način možete poslati zahtjev ukoliko trebate servisirati
                ma&scaron;inu koja ne radi. U tom slučaju je veoma bitno poslati slike kako bi
                Eurosan serviseri mogli točno znati o čemu se radi.
              </p>
              <p>
                Za sve dodatne informacije možete kontaktirati svog prodajnog predstavnika, pozvati
                nas na
                <strong
                  >080 080 080 ili poslati e-mail na
                  <a href="mailto:webshop@eurosan.ba">webshop@eurosan.ba.</a></strong
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Complaints',
};
</script>
